import React, { useEffect, useMemo } from 'react';

import { constants, ResponsibleApi, SiteConfigManager, useSelfRegulation } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import Limits from './Limits/Limits';

const { DEPOSIT, GAME_SPENT, SPENT, SPORT_SPENT } = constants.SELF_REGULATION_LIMIT;
const BASE_LIMITS = [DEPOSIT, SPENT];
const ALL_LIMITS = [...BASE_LIMITS, GAME_SPENT, SPORT_SPENT];

const SelfRegulation = () => {
  const { checkCommonSpentLimit, checkNotCommonSpentLimit, setRegulationLimit, state } =
    useSelfRegulation();
  const navigation = SiteConfigManager.getConfig('config.pages', []);

  const casinoEnabled = navigation.some(
    ({ isActive, type }) =>
      (type === COMPONENT_TYPES.CASINO || type === COMPONENT_TYPES.CASINO_LIVE) && isActive,
  );

  const sportsBookEnabled = navigation.find(
    ({ isActive, type }) => type === COMPONENT_TYPES.SPORT_PREMATCH && isActive,
  );

  const visibleLimits = useMemo(() => {
    return [...BASE_LIMITS, casinoEnabled && GAME_SPENT, sportsBookEnabled && SPORT_SPENT].filter(
      Boolean,
    );
  }, [casinoEnabled, sportsBookEnabled]);

  useEffect(() => {
    ALL_LIMITS.forEach(limit => {
      ResponsibleApi[limit === DEPOSIT ? 'getClientDepositLimits' : 'getClientLossLimits']({
        type: limit,
      }).then(data => {
        setRegulationLimit(data, limit);
      });
    });
  }, [setRegulationLimit]);

  return (
    <div className="self-regulation">
      {visibleLimits.map(limit => (
        <Limits
          checkCommonSpentLimit={checkCommonSpentLimit}
          checkNotCommonSpentLimit={checkNotCommonSpentLimit}
          key={limit}
          limitType={limit}
          regulationLimit={state[limit]}
          setRegulationLimit={setRegulationLimit}
        />
      ))}
    </div>
  );
};

export default SelfRegulation;
